<template>
  <div class="modal-body">
    <div class="d-flex justify-content-between align-items-center mb-4 modal-header-section">
      <h5 class="modal-title">Account Profile</h5>
      <div class="d-flex align-items-center">
        <p class="account-profile-item-text">EAID:{{ cardStore.cardInfo?.EAID }}</p>
        <button type="button" class="close-btn" @click="$emit('close')">X</button>
      </div>
    </div>
    
    <div >
      <div class="account-profile-tabs">
        <label
        v-for="tab in tabs"
        :key="tab"
        class="account-profile-item"
        :class="{ active: activeTab === tab }"
        @click="setActiveTab(tab)"
      >
        {{ tab }}
      </label>
      </div>
      <div class="account-profile-content-container">
      <div class="account-profile-content">
      <div class="account-profile-cardDetail" v-if="activeTab === 'Overview'" >
        <div class="account-profile-cardDetail-header">
          <h5>Card details</h5>
        </div>
          <div class="account-profile-cardDetail-content">
            <div class="account-profile-cardDetail-content-item">
              <span>EAID</span>
              <p>{{ cardStore.cardInfo?.EAID }}</p>
            </div>
            <div class="account-profile-cardDetail-content-item">
              <span>Status</span>
              <p>{{ cardStore.cardInfo?.status }}</p>
            </div>
          </div>
          <div class="account-profile-cardDetail-content">
            <div class="account-profile-cardDetail-content-item">
              <span>Start date</span>
              <p>{{ cardStore.cardInfo?.start_date }}</p>
            </div>
            <div class="account-profile-cardDetail-content-item">
              <span>Expiry date</span>
              <p>{{ cardStore.cardInfo?.eml_account_data?.expiry_date }}</p>
            </div>
          </div>
          <hr>
          <div class="account-profile-cardDetail-content">
            <div class="account-profile-cardDetail-content-item">
              <span>Available amount</span>
              <p style="font-size: 24px;">{{ cardStore.cardInfo?.eml_account_data?.balance }}</p>
            </div>
            <div class="account-profile-cardDetail-content-item">
              <span>Pending</span>
              <p>$0</p>
            </div>
          </div>

      </div>
      
      <!-- Right Side Container -->
      <div class="account-profile-right-section" v-if="activeTab === 'Overview'">
        <div class="account-profile-Assignment">
          <div class="assignment-header">
            <h5>Assignment</h5>
          </div>
          <div class="assignment-form">
            <div class="assignment-form-group">
              <label for="driver-id">Driver ID</label>
              <input type="text" id="driver-id" class="assignment-input" v-model="driverId"  />
            </div>
            <div class="assignment-form-group">
              <label for="driver-name">Name</label>
              <input type="text" id="driver-name" class="assignment-input assignment-input-disabled" v-model="driverName"  disabled />
            </div>
          </div>
          <div class="assignment-buttons">
            <button class="btn-save" @click="handleSave">Save</button>
            <button class="btn-cancel" @click="handleCancel">Cancel</button>
          </div>
        </div>

        <!-- Card Renewal Method -->
        <div class="card-renewal-section">
          <div class="renewal-header">
            <h5>Card renewal method</h5>
          </div>
          <div class="renewal-options">
            <label class="renewal-checkbox-label">
              <input 
                type="checkbox" 
                class="renewal-checkbox" 
                v-model="renewalByMail"
               
              />
              <span class="checkbox-custom" :class="{ checked : renewalByMail }">
                <i v-if="renewalByMail" class="fa fa-check"></i>
              </span>
              <span class="renewal-text">By mail</span>
            </label>
            <label class="renewal-checkbox-label">
              <input 
                type="checkbox" 
                class="renewal-checkbox" 
                v-model="renewalOfficePickup"
               
              />
              <span class="checkbox-custom" :class="{ checked: renewalOfficePickup }">
                <i v-if="renewalOfficePickup" class="fa fa-check"></i>
              </span>
              <span class="renewal-text">Office pickup</span>
            </label>
          </div>
        </div>
      </div>
      
    </div>
    
    <!-- ------------------------------------------------------------ -->
    <div class="card-actions-section" v-if="activeTab === 'Overview'" >
      <div class="switch-row">
        <div class="custom-switch-group">
          <label class="custom-switch">
            <input type="checkbox" :checked="lockCard" @change="onSwitch('lock', $event)" :disabled="showPopover || isLockCardDisabled || lostStolen">
            <span class="custom-slider" :class="{ checked: lockCard }"></span>
          </label>
          <span class="switch-label">Temporarily lock card</span>
          <div v-if="showPopover && popoverType === 'lock'" class="switch-popover-mask" @click.self="cancelSwitch">
            <div class="switch-popover" ref="popoverRef" tabindex="0">
              <div class="popover-content">
                <div class="popover-title">Are you sure you want to temporarily lock this card?</div>
                <div class="popover-actions">
                  <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                  <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="custom-switch-group">
          <label class="custom-switch">
            <input type="checkbox" :checked="lostStolen" @change="onSwitch('lost', $event)" :disabled="showPopover || isLostStolenDisabled">
            <span class="custom-slider" :class="{ checked: lostStolen }"></span>
          </label>
          <span class="switch-label">Lost / stolen</span>
          <!-- 標記為 lost/stolen 時的提示窗（開關關閉，要開啟） -->
          <div v-if="showPopover && popoverType === 'lost'" class="switch-popover-mask" @click.self="cancelSwitch">
            <div class="switch-popover" ref="popoverRef" tabindex="0">
              <div class="popover-content">
                <div class="popover-title">Are you sure you want to mark the card as lost or stolen?</div>
                <div class="popover-desc">
                  <p>This will temporarily disable all transactions to keep your card secure.</p>
                  <p>If you find your card, you can unlock it here as well.</p>
                  <p>If the card cannot be recovered, contact customer service to arrange a replacement – a $15 reissue fee will apply.</p>
                </div>
                <div class="popover-actions">
                  <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                  <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                </div>
              </div>
            </div>
          </div>
          <!-- 移除 lost/stolen 狀態時的提示窗（開關已開啟，要關閉） -->
          <div v-if="showPopover && popoverType === 'remove-lost-stolen'" class="switch-popover-mask" @click.self="cancelSwitch">
            <div class="switch-popover" ref="popoverRef" tabindex="0">
              <div class="popover-content">
                <div class="popover-title">Are you sure you want to remove the lost / stolen status?</div>
                <div class="popover-desc">Your card will be active again and ready to use for all transactions.</div>
                <div class="popover-actions">
                  <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                  <button class="btn-link text-primary" @click="confirmSwitch">YES</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="deactivate-cancel-container">
        <a href="#" class="deactivate-link" @click.prevent="showDeactivatePopover">Deactivate / cancel card</a>
        <div v-if="showPopover && popoverType === 'deactivate-cancel'" class="switch-popover-mask deactivate-popover-mask" @click.self="cancelSwitch">
          <div class="switch-popover" ref="popoverRef" tabindex="0">
            <div class="popover-content">
              <div class="popover-title">Are you sure you want to deactivate this card?</div>
              <div class="popover-desc">Once deactivated, this card will be permanently blocked.</div>
              <div class="popover-actions">
                <button class="btn-link text-secondary" @click="cancelSwitch">Cancel</button>
                <button class="btn-link text-primary" @click="confirmDeactivateCancel">YES</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeTab === 'Card history'">
      <CardHistory />
    </div>
    <div v-if="activeTab === 'Card transactions'">
      <CardTransactions />
    </div>
    <div v-if="activeTab === 'Transfer funds'"> 
      <TransferFunds />
    </div>

  </div>
     
    </div>
    
  </div>
</template>

<script setup>
import { ref, watch ,onMounted } from 'vue';
import { useCardStore } from '@/store/admin/card'
import CardHistory from './cardHistory.vue';
import CardTransactions from './cardTransactions.vue';
import TransferFunds from './transferFunds.vue';
import Swal from 'sweetalert2';

const cardStore =useCardStore();

const props = defineProps({
  driver_id: {
    type: [String, Number],
    default: null
  },
  eaid: {
    type: [String, Number],
    default: null
  }
});




const fetchOptionsFromContext = () => {
  const eaid = props.eaid ?? cardStore.cardInfo?.EAID ?? cardStore.cardInfo?.eaid;
  if (eaid == null || eaid === '') return {};
  return { eaid };
};

// 當 driver_id / eaid 變化時，重新獲取資料
watch(
  () => [props.driver_id, props.eaid],
  ([newDriverId]) => {
    if (newDriverId) {
      const opts = props.eaid != null && props.eaid !== '' ? { eaid: props.eaid } : {};
      cardStore.fetchCardInfo(newDriverId, opts);
    }
  },
  { immediate: true }
);



defineEmits(['close']);

const tabs = ['Overview', 'Card history', 'Card transactions', 'Transfer funds'];
const activeTab = ref(tabs[0]);

const setActiveTab = (tab) => {
  activeTab.value = tab;
};

const driverId = ref(cardStore.cardInfo?.driver?.driver_id || null);
const driverName = ref(cardStore.cardInfo?.driver?.assigned_to || null);

watch(() => cardStore.cardInfo?.driver?.driver_id, (newDriverId) => {
  if (newDriverId) {
    driverId.value = newDriverId;
  }
}, { immediate: true });

watch(() => cardStore.cardInfo?.driver?.assigned_to, (newDriverName) => {
  if (newDriverName) {
    driverName.value = newDriverName;
  }
}, { immediate: true });

const lockCard = ref(false);
const lostStolen = ref(false);
const showPopover = ref(false);
const popoverType = ref('');
const popoverRef = ref(null);
const isLockCardDisabled = ref(false);
const isLostStolenDisabled = ref(false);

// Card Renewal Method
const renewalByMail = ref(false);
const renewalOfficePickup = ref(false);

watch(renewalByMail,(v) =>{ if(v) renewalOfficePickup.value = false;});
watch(renewalOfficePickup,(v) =>{ if(v) renewalByMail.value = false;});

watch(() => cardStore.cardInfo?.app_type, (newAppType) => {
  if (newAppType === 0) {
    renewalByMail.value = true;
    renewalOfficePickup.value = false;
  } else if (newAppType === 1) {
    renewalByMail.value = false;
    renewalOfficePickup.value = true;
  }
}, { immediate: true });





watch(() => cardStore.cardInfo?.status, (newStatus) => {
  if (newStatus === 'inactive') {
    lockCard.value = true;
  } else {
    lockCard.value = false;
  }
  if (newStatus === 'lost_or_stolen') {
    lostStolen.value = true;
  } else {
    lostStolen.value = false;
  }
}, { immediate: true });

// 監聽 lostStolen 的變化，當卡片遺失時，自動關閉 lock card 並禁用
watch(() => lostStolen.value, (isLost) => {
  if (isLost) {
    // 如果卡片遺失，自動關閉 lock card
    lockCard.value = false;
    // 禁用 lock card 開關
    isLockCardDisabled.value = true;
  } else {
    // 如果卡片未遺失，恢復 lock card 開關的可用狀態
    isLockCardDisabled.value = false;
  }
}, { immediate: true });


const onSwitch = (type, event) => {
  // 阻止 checkbox 的默認行為
  event.preventDefault();
  
  if (showPopover.value) return;
  
  if (type === 'lock') {
    // 如果卡片遺失，不允許操作 lock card 開關
    if (lostStolen.value) {
      return;
    }
    popoverType.value = type;
    showPopover.value = true;
  } else if (type === 'lost') {
    if (lostStolen.value) {
      // 開→關，移除 lost/stolen 狀態，顯示移除提示窗
      popoverType.value = 'remove-lost-stolen';
      showPopover.value = true;
    } else {
      // 關→開，標記為 lost/stolen，顯示標記提示窗
      popoverType.value = type;
      showPopover.value = true;
    }
  }
};

const cancelSwitch = () => {
  showPopover.value = false;
  popoverType.value = '';
};

const confirmSwitch = async () => {
  const driverId = cardStore.cardInfo?.driver?.id || cardStore.cardInfo?.driver?.driver_id;
  
  if (popoverType.value === 'lock') {
    const action = cardStore.cardInfo?.status === 'inactive' ? 'unlock' : 'lock';
   
    if (driverId) {
      try {
        await cardStore.lockCard(driverId, action, fetchOptionsFromContext());
        await cardStore.fetchCardInfo(driverId, fetchOptionsFromContext());
        showPopover.value = false;
        
        // 顯示成功訊息
        Swal.fire({
          title: 'Success',
          text: action === 'lock' ? 'Card has been temporarily locked' : 'Card has been unlocked',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } catch (error) {
        console.error('Failed to lock/unlock card:', error);
        showPopover.value = false;
        
        // 顯示錯誤訊息
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Failed to lock/unlock card',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    }
  } else if (popoverType.value === 'lost') {
    // 標記為 lost/stolen（開關關閉，要開啟）
    if (driverId) {
      try {
        await cardStore.lostCard(driverId, fetchOptionsFromContext());
        await cardStore.fetchCardInfo(driverId, fetchOptionsFromContext());
        showPopover.value = false;
        
        // 顯示成功訊息
        Swal.fire({
          title: 'Success',
          text: 'Card has been marked as lost/stolen',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } catch (error) {
        console.error('Failed to mark card as lost:', error);
        showPopover.value = false;
        
        // 顯示錯誤訊息
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.error,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    }
  } else if (popoverType.value === 'remove-lost-stolen') {
    // 移除 lost/stolen 狀態（開關已開啟，要關閉）
    // 使用 lockCard 的 unlock action 來激活卡片
    if (driverId) {
      try {
        await cardStore.lockCard(driverId, 'unlock', fetchOptionsFromContext());
        await cardStore.fetchCardInfo(driverId, fetchOptionsFromContext());
        showPopover.value = false;
        
        // 顯示成功訊息
        Swal.fire({
          title: 'Success',
          text: 'Lost/stolen status has been removed. Card is now active.',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } catch (error) {
        console.error('Failed to remove lost/stolen status:', error);
        showPopover.value = false;
        
        // 顯示錯誤訊息
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Failed to remove lost/stolen status',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    }
  }
  
  popoverType.value = '';
};

const showDeactivatePopover = () => {
  popoverType.value = 'deactivate-cancel';
  showPopover.value = true;
};

const confirmDeactivateCancel = async () => {
  // 處理停用/取消卡片的邏輯
  const driverId = cardStore.cardInfo?.driver?.id || cardStore.cardInfo?.driver?.driver_id;
  
  if (!driverId) {
    console.error('Driver ID not found');
    showPopover.value = false;
    popoverType.value = '';
    Swal.fire({
      title: 'Error',
      text: 'Driver ID not found',
      icon: 'error',
      confirmButtonText: 'OK'
    });
    return;
  }
  
  showPopover.value = false;
  popoverType.value = '';
  
  try {
    const result = await Swal.fire({
      title: 'This action is permanent. Once deactivated, this card cannot be used again.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Permanently deactivate',
      cancelButtonText: 'Cancel'
    });
    
    if (result.isConfirmed) {
      try {
        await cardStore.lockCard(driverId, 'closed', fetchOptionsFromContext());
        // 成功後重新載入卡片資訊以更新狀態
        await cardStore.fetchCardInfo(driverId, fetchOptionsFromContext());
        
        // 顯示成功訊息
        Swal.fire({
          title: 'Success',
          text: 'Card has been permanently deactivated',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } catch (error) {
        console.error('Failed to deactivate card:', error);
        // 顯示錯誤訊息
        Swal.fire({
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Failed to deactivate card',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    }
  } catch (error) {
    console.error('Error during deactivate process:', error);
  }
};

const handleSave = async () => {
  try {
    const payload = {
      EAID: cardStore.cardInfo?.EAID,
      driver_id: driverId.value
    };
    const response = await cardStore.assignCard(payload);
    
    // 如果成功，顯示成功訊息
    if (response && response.success) {
      Swal.fire({
        title: 'Success',
        text: 'Card assigned successfully',
        icon: 'success',
        confirmButtonText: 'OK'
      });
      
     
    }
  } catch (error) {
    // 顯示錯誤訊息給使用者
    const errorMessage = error.response?.data?.message || error.message || 'Failed to assign card';
    Swal.fire({
      title: 'Error',
      text: errorMessage,
      icon: 'error',
      confirmButtonText: 'OK'
    });
    console.error('Failed to assign card:', error);
  }
};

const renewCard = async () => {
  try{
    
  } catch(error){

  }
}



</script>

<style scoped>
.modal-body{
  background-color:#E6E9EC;
  border-radius:10px;
  padding:20px;
  width:100%;
}
.modal-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}
.account-profile-cardDetail-header{
  margin-bottom:20px;
}
.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #000;
}

.account-profile-tabs {
  display: flex;
  margin: 0;
  padding: 0;
  gap: 0;
}

.account-profile-item {
  font-family: Mulish, sans-serif;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 10px 10px 0 0;
  color: #475467;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  margin: 0;
}

.account-profile-item.active {
  background-color: #ffffff;
  color: #111827;
  
  position: relative;
  z-index: 1;
}

.account-profile-item-text{
  font-family: Mulish;
  font-size: 16px;
  font-weight: 400;
  line-height: 22.59px;
  text-align: left;
  padding-right:20px;
  color:#5E707D;
}
.account-profile-content-container{
  background-color: white;
  border-radius: 0 10px 10px 10px; /* 只有右側和下方有圓角，左側和上方與標籤對齊 */
  padding: 20px;
  margin-top: -1px; /* 讓內容區塊與標籤緊貼，消除間隙 */
  position: relative;
  z-index: 0;
  gap:15px;
  height:650px;
  overflow-y: auto;
}
.account-profile-content {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
.account-profile-cardDetail{
  width: 60%;
  border:1px solid black;
  border-radius:10px;
  padding:20px;
}

/* Right Side Container */
.account-profile-right-section {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.account-profile-Assignment {
  width: 100%;
  background-color: #E6E9EC;
  
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 220px;
  min-height: 220px;
}

.assignment-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.assignment-form {
  display: flex;

  gap: 16px;
}

.assignment-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.assignment-form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin: 0;
}

.assignment-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  font-size: 14px;
  background-color: #ffffff;
  color: #111827;
  box-sizing: border-box;
}

.assignment-input:focus {
  outline: none;
  border-color: #5248DA;
}

.assignment-input-disabled {
  background-color: #F2F4F7;
  color: #111827;
  cursor: not-allowed;
}

.assignment-buttons {
  display: flex;
  gap: 12px;
  margin-top: auto;
  max-width:70%;
}

.btn-save {
  flex: 1;
  padding: 12px 24px;
  background-color: #00C962;
  color:black;
  border: none;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-save:hover {
  background-color: #00b452;
}

.btn-cancel {
  flex: 1;
  padding: 12px 24px;
  background-color: #ffffff;
  color: #5248DA;
  border: 2px solid #5248DA;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-cancel:hover {
  background-color: #f8f9fa;
}

/* Card Renewal Method Section */
.card-renewal-section {
  width: 100%;
  background-color: #E6E9EC;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 150px;
  min-height: 150px;
}

.renewal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.renewal-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.renewal-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
  user-select: none;
}

.renewal-checkbox {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-custom {
  width: 24px;
  height: 24px;
  border: 2px solid #D0D5DD;
  border-radius: 4px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.checkbox-custom.checked {
  background-color: #00C962;
  border-color: #00C962;
}

.checkbox-custom i {
  color: #ffffff;
  font-size: 14px;
}

.renewal-text {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
}

.renewal-checkbox-label:hover .checkbox-custom {
  border-color: #00C962;
}

.account-profile-cardDetail-content{
  display: flex;
  justify-content:space-between;
  align-items:center;
  
}

.account-profile-cardDetail-content-item{
  width:50%;
  text-align:left;
  font-size: 16px;
}
.custom-switch {
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 44px;
    height: 24px;
    vertical-align: middle;
}
.custom-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
.custom-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    border: 2px solid #22313f;
    border-radius: 24px;
    transition: .2s;
}
.custom-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 2px;
    bottom: 2px;
    background-color: #22313f;
    border-radius: 50%;
    transition: .2s;
}
.custom-slider.checked {
    border: 2px solid #00C962;
    background: #fff;
}
.custom-slider.checked:before {
    background-color:#00C962;
    left: 22px;
}

.card-actions-section {
  background-color: white;
  border-radius: 0 10px 10px 10px;
  padding: 20px;
  margin-top: -1px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.switch-row {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.custom-switch-group {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  min-height: 32px;
}

.switch-label {
  font-family: 'Mulish', sans-serif;
  font-size: 16px;
  color: #22313f;
  vertical-align: middle;
  display: flex;
  align-items: center;
}

.switch-popover-mask {
  position: absolute;
  left: 60px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2000;
  pointer-events: all;
}

.switch-popover {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  border: 2px solid #a398f7;
  padding: 24px 32px 20px 32px;
  min-width: 400px;
  max-width: 90vw;
  text-align: left;
  outline: none;
  pointer-events: all;
}

.popover-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.popover-title {
  font-size: 18px;
  
  color: #22313f;
  margin: 0;
}

.popover-desc {
  font-size: 14px;
  color: #667085;
  line-height: 1.5;
  margin: 0;
}

.popover-actions {
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  margin-top: 8px;
}

.btn-link {
  background: none;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.btn-link.text-secondary {
  color: #667085;
}

.btn-link.text-secondary:hover {
  background-color: #f2f4f7;
}

.btn-link.text-primary {
  color: #5248DA;
}

.btn-link.text-primary:hover {
  background-color: #f0efff;
}

.deactivate-cancel-container {
  position: relative;
}

.deactivate-link {
  color: #5248DA;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
}

.deactivate-link:hover {
  color: #4238c9;
}

.deactivate-popover-mask {
  position: absolute;
  left: 200px;
  top: 10px;
  z-index: 2000;
  pointer-events: all;
}

/* 手機版響應式設計 */
@media (max-width: 768px) {
  .modal-body {
    padding: 15px;
    border-radius: 0;
  }

  /* 標題區域 */
  .modal-header-section {
    flex-wrap: wrap;
    gap: 10px;
  }

  .modal-title {
    font-size: 18px;
    flex: 1;
    min-width: 150px;
  }

  .account-profile-item-text {
    font-size: 12px;
    padding-right: 10px;
    white-space: nowrap;
  }

  .close-btn {
    font-size: 20px;
    width: 25px;
    height: 25px;
  }

  /* 標籤頁 */
  .account-profile-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .account-profile-tabs::-webkit-scrollbar {
    display: none;
  }

  .account-profile-item {
    font-size: 14px;
    padding: 8px 15px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* 內容容器 */
  .account-profile-content-container {
    border-radius: 0 0 10px 10px;
    padding: 15px;
    height: calc(100vh - 200px);
    min-height: 400px;
  }

  /* 內容區域改為垂直排列 */
  .account-profile-content {
    flex-direction: column;
    gap: 15px;
  }

  /* Card details */
  .account-profile-cardDetail {
    width: 100%;
    padding: 15px;
  }

  /* Right section also full width on mobile */
  .account-profile-right-section {
    width: 100%;
  }

  .account-profile-cardDetail-header h5 {
    font-size: 16px;
  }

  .account-profile-cardDetail-content {
    flex-direction: column;
    gap: 12px;
  }

  .account-profile-cardDetail-content-item {
    width: 100%;
    font-size: 14px;
  }

  .account-profile-cardDetail-content-item p {
    font-size: 20px !important;
    margin: 4px 0;
  }

  /* Assignment */
  .account-profile-Assignment {
    width: 100%;
    padding: 15px;
  }

  .assignment-header h5 {
    font-size: 16px;
  }

  .assignment-form {
    flex-direction: column;
    gap: 12px;
  }

  .assignment-form-group {
    width: 100%;
  }

  .assignment-buttons {
    max-width: 100%;
    flex-direction: column;
    gap: 10px;
  }

  .btn-save,
  .btn-cancel {
    width: 100%;
    padding: 12px 20px;
  }

  /* Card Renewal Section */
  .card-renewal-section {
    width: 100%;
    padding: 15px;
  }

  .renewal-header h5 {
    font-size: 16px;
  }

  /* Card actions section */
  .card-actions-section {
    border-radius: 0 0 10px 10px;
    padding: 15px;
  }

  .switch-label {
    font-size: 14px;
    flex: 1;
  }

  .custom-switch-group {
    flex-wrap: wrap;
    gap: 8px;
  }

  /* Popover 調整 */
  .switch-popover-mask {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .switch-popover {
    min-width: auto;
    width: 100%;
    max-width: 90vw;
    padding: 20px;
    margin: 0;
  }

  .popover-title {
    font-size: 16px;
  }

  .popover-desc {
    font-size: 13px;
  }

  .popover-actions {
    flex-direction: column;
    gap: 10px;
  }

  .btn-link {
    width: 100%;
    text-align: center;
    padding: 10px 16px;
  }

  .deactivate-popover-mask {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }
}

/* 小手機版 (小於 576px) */
@media (max-width: 576px) {
  .modal-body {
    padding: 10px;
  }

  .modal-title {
    font-size: 16px;
  }

  .account-profile-item-text {
    font-size: 11px;
    padding-right: 8px;
  }

  .account-profile-item {
    font-size: 12px;
    padding: 6px 12px;
  }

  .account-profile-content-container {
    padding: 12px;
    height: calc(100vh - 180px);
  }

  .account-profile-cardDetail,
  .account-profile-Assignment,
  .card-renewal-section {
    padding: 12px;
  }

  .account-profile-cardDetail-content-item {
    font-size: 13px;
  }

  .account-profile-cardDetail-content-item p {
    font-size: 18px !important;
  }

  .card-actions-section {
    padding: 12px;
  }

  .switch-popover {
    padding: 16px;
  }

  .popover-title {
    font-size: 15px;
  }
}
</style>
